import React from 'react';

export function EDTIllustration() {
  return (
    <svg
      width="390"
      height="240"
      viewBox="0 0 390 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_348_160)">
        <rect
          x="20"
          y="16"
          width="349.78"
          height="200"
          rx="6.92641"
          fill="white"
        />
        <mask id="path-2-inside-1_348_160" fill="white">
          <path d="M26.9265 26.3896H44.2425V47.1688H26.9265V26.3896Z" />
        </mask>
        <path
          d="M44.2425 47.1688V46.303H26.9265V47.1688V48.0346H44.2425V47.1688Z"
          fill="#DCE0E9"
          mask="url(#path-2-inside-1_348_160)"
        />
        <mask id="path-4-inside-2_348_160" fill="white">
          <path d="M26.9264 47.1688H44.2425V73.5758H26.9264V47.1688Z" />
        </mask>
        <path
          d="M44.2425 73.5758V72.7099H26.9264V73.5758V74.4416H44.2425V73.5758Z"
          fill="#DCE0E9"
          mask="url(#path-4-inside-2_348_160)"
        />
        <mask id="path-6-inside-3_348_160" fill="white">
          <path d="M26.9264 73.5757H44.2425V99.9827H26.9264V73.5757Z" />
        </mask>
        <path
          d="M44.2425 99.9827V99.1169H26.9264V99.9827V100.848H44.2425V99.9827Z"
          fill="#DCE0E9"
          mask="url(#path-6-inside-3_348_160)"
        />
        <mask id="path-8-inside-4_348_160" fill="white">
          <path d="M26.9264 99.9827H44.2425V126.39H26.9264V99.9827Z" />
        </mask>
        <path
          d="M44.2425 126.39V125.524H26.9264V126.39V127.255H44.2425V126.39Z"
          fill="#DCE0E9"
          mask="url(#path-8-inside-4_348_160)"
        />
        <mask id="path-10-inside-5_348_160" fill="white">
          <path d="M26.9264 126.39H44.2425V152.797H26.9264V126.39Z" />
        </mask>
        <path
          d="M44.2425 152.797V151.931H26.9264V152.797V153.662H44.2425V152.797Z"
          fill="#DCE0E9"
          mask="url(#path-10-inside-5_348_160)"
        />
        <mask id="path-12-inside-6_348_160" fill="white">
          <path d="M26.9264 152.797H44.2425V179.203H26.9264V152.797Z" />
        </mask>
        <path
          d="M44.2425 179.203V178.338H26.9264V179.203V180.069H44.2425V179.203Z"
          fill="#DCE0E9"
          mask="url(#path-12-inside-6_348_160)"
        />
        <mask id="path-14-inside-7_348_160" fill="white">
          <path d="M26.9264 179.203H44.2425V205.61H26.9264V179.203Z" />
        </mask>
        <path
          d="M44.2425 205.61V204.745H26.9264V205.61V206.476H44.2425V205.61Z"
          fill="#DCE0E9"
          mask="url(#path-14-inside-7_348_160)"
        />
        <rect
          x="66.7533"
          y="26.3896"
          width="41.5584"
          height="5.19481"
          rx="2.5974"
          fill="#959CB1"
        />
        <rect
          x="51.1689"
          y="45.4372"
          width="72.7273"
          height="14.7186"
          rx="3.4632"
          fill="#91ABF1"
        />
        <rect
          x="51.1688"
          y="63.619"
          width="72.7273"
          height="8.65801"
          rx="3.4632"
          fill="#E8EAF0"
        />
        <rect
          x="51.1688"
          y="75.7403"
          width="72.7273"
          height="30.303"
          rx="3.4632"
          fill="#D8EF95"
        />
        <rect
          x="51.1688"
          y="109.506"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFB3C2"
        />
        <rect
          x="51.1688"
          y="135.481"
          width="72.7273"
          height="44.1558"
          rx="3.4632"
          fill="#BDC9EA"
        />
        <rect
          x="51.1688"
          y="183.1"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFA573"
        />
        <rect
          x="146.407"
          y="26.3896"
          width="41.5584"
          height="5.19481"
          rx="2.5974"
          fill="#959CB1"
        />
        <rect
          x="130.822"
          y="45.4372"
          width="72.7273"
          height="8.65801"
          rx="3.4632"
          fill="#E8EAF0"
        />
        <rect
          x="130.822"
          y="57.5584"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFB3C2"
        />
        <rect
          x="130.822"
          y="83.5325"
          width="72.7273"
          height="14.7186"
          rx="3.4632"
          fill="#91ABF1"
        />
        <rect
          x="130.822"
          y="101.714"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFA573"
        />
        <rect
          x="130.822"
          y="127.688"
          width="72.7273"
          height="44.1558"
          rx="3.4632"
          fill="#BDC9EA"
        />
        <rect
          x="130.822"
          y="175.307"
          width="72.7273"
          height="30.303"
          rx="3.4632"
          fill="#D8EF95"
        />
        <rect
          x="226.061"
          y="26.3896"
          width="41.5584"
          height="5.19481"
          rx="2.5974"
          fill="#959CB1"
        />
        <rect
          x="210.476"
          y="45.4372"
          width="72.7273"
          height="8.65801"
          rx="3.4632"
          fill="#E8EAF0"
        />
        <rect
          x="210.476"
          y="57.5584"
          width="72.7273"
          height="30.303"
          rx="3.4632"
          fill="#D8EF95"
        />
        <rect
          x="210.476"
          y="91.3247"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFB3C2"
        />
        <rect
          x="210.476"
          y="117.299"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFA573"
        />
        <rect
          x="210.476"
          y="143.273"
          width="72.7273"
          height="44.1558"
          rx="3.4632"
          fill="#BDC9EA"
        />
        <rect
          x="210.476"
          y="190.892"
          width="72.7273"
          height="14.7186"
          rx="3.4632"
          fill="#91ABF1"
        />
        <rect
          x="305.714"
          y="26.3896"
          width="41.5584"
          height="5.19481"
          rx="2.5974"
          fill="#959CB1"
        />
        <rect
          x="290.13"
          y="45.4372"
          width="72.7273"
          height="30.303"
          rx="3.4632"
          fill="#D8EF95"
        />
        <rect
          x="290.13"
          y="79.2035"
          width="72.7273"
          height="14.7186"
          rx="3.4632"
          fill="#91ABF1"
        />
        <rect
          x="290.13"
          y="97.3853"
          width="72.7273"
          height="8.65801"
          rx="3.4632"
          fill="#E8EAF0"
        />
        <rect
          x="290.13"
          y="109.506"
          width="72.7273"
          height="44.1558"
          rx="3.4632"
          fill="#BDC9EA"
        />
        <rect
          x="290.13"
          y="157.126"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFA573"
        />
        <rect
          x="290.13"
          y="183.1"
          width="72.7273"
          height="22.5108"
          rx="3.4632"
          fill="#FFB3C2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_348_160"
          x="0"
          y="0"
          width="389.78"
          height="240"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_348_160"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_348_160"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function EDTFromScratchIllustration() {
  return (
    <svg
      width="256"
      height="180"
      viewBox="0 0 256 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_302_34841)">
        <rect
          x="20.4017"
          y="16"
          width="215.197"
          height="140"
          rx="4.89083"
          fill="white"
        />
        <rect
          x="36.297"
          y="23.3363"
          width="29.345"
          height="3.66812"
          rx="1.83406"
          fill="#959CB1"
        />
        <mask id="path-3-inside-1_302_34841" fill="white">
          <path d="M25.2926 36.7861H76.6463V55.4324H25.2926V36.7861Z" />
        </mask>
        <path
          d="M25.2926 36.7861V37.4004H76.6463V36.7861V36.1718H25.2926V36.7861ZM76.6463 55.4324V54.821H25.2926V55.4324V56.0437H76.6463V55.4324Z"
          fill="#DCE0E9"
          mask="url(#path-3-inside-1_302_34841)"
        />
        <mask id="path-5-inside-2_302_34841" fill="white">
          <path d="M25.2926 55.4324H76.6463V74.0787H25.2926V55.4324Z" />
        </mask>
        <path
          d="M76.6463 74.0787V73.4673H25.2926V74.0787V74.69H76.6463V74.0787Z"
          fill="#DCE0E9"
          mask="url(#path-5-inside-2_302_34841)"
        />
        <mask id="path-7-inside-3_302_34841" fill="white">
          <path d="M25.2926 74.0786H76.6463V92.7249H25.2926V74.0786Z" />
        </mask>
        <path
          d="M76.6463 92.7249V92.1135H25.2926V92.7249V93.3363H76.6463V92.7249Z"
          fill="#DCE0E9"
          mask="url(#path-7-inside-3_302_34841)"
        />
        <mask id="path-9-inside-4_302_34841" fill="white">
          <path d="M25.2926 92.7249H76.6463V111.371H25.2926V92.7249Z" />
        </mask>
        <path
          d="M76.6463 111.371V110.76H25.2926V111.371V111.983H76.6463V111.371Z"
          fill="#DCE0E9"
          mask="url(#path-9-inside-4_302_34841)"
        />
        <mask id="path-11-inside-5_302_34841" fill="white">
          <path d="M25.2926 111.371H76.6463V130.017H25.2926V111.371Z" />
        </mask>
        <path
          d="M76.6463 130.017V129.406H25.2926V130.017V130.629H76.6463V130.017Z"
          fill="#DCE0E9"
          mask="url(#path-11-inside-5_302_34841)"
        />
        <mask id="path-13-inside-6_302_34841" fill="white">
          <path d="M25.2926 130.018H76.6463V148.664H25.2926V130.018Z" />
        </mask>
        <path
          d="M76.6463 148.664V148.052H25.2926V148.664V149.275H76.6463V148.664Z"
          fill="#DCE0E9"
          mask="url(#path-13-inside-6_302_34841)"
        />
        <rect
          x="87.6506"
          y="23.3363"
          width="29.345"
          height="3.66812"
          rx="1.83406"
          fill="#959CB1"
        />
        <mask id="path-16-inside-7_302_34841" fill="white">
          <path d="M76.6462 36.7861H128V55.4324H76.6462V36.7861Z" />
        </mask>
        <path
          d="M76.6462 36.7861V37.4004H128V36.7861V36.1718H76.6462V36.7861ZM128 55.4324V54.821H76.6462V55.4324V56.0437H128V55.4324Z"
          fill="#DCE0E9"
          mask="url(#path-16-inside-7_302_34841)"
        />
        <mask id="path-18-inside-8_302_34841" fill="white">
          <path d="M76.6462 55.4324H128V74.0787H76.6462V55.4324Z" />
        </mask>
        <path
          d="M128 74.0787V73.4673H76.6462V74.0787V74.69H128V74.0787Z"
          fill="#DCE0E9"
          mask="url(#path-18-inside-8_302_34841)"
        />
        <mask id="path-20-inside-9_302_34841" fill="white">
          <path d="M76.6462 74.0786H128V92.7249H76.6462V74.0786Z" />
        </mask>
        <path
          d="M128 92.7249V92.1135H76.6462V92.7249V93.3363H128V92.7249Z"
          fill="#DCE0E9"
          mask="url(#path-20-inside-9_302_34841)"
        />
        <mask id="path-22-inside-10_302_34841" fill="white">
          <path d="M76.6462 92.7249H128V111.371H76.6462V92.7249Z" />
        </mask>
        <path
          d="M128 111.371V110.76H76.6462V111.371V111.983H128V111.371Z"
          fill="#DCE0E9"
          mask="url(#path-22-inside-10_302_34841)"
        />
        <mask id="path-24-inside-11_302_34841" fill="white">
          <path d="M76.6462 111.371H128V130.017H76.6462V111.371Z" />
        </mask>
        <path
          d="M128 130.017V129.406H76.6462V130.017V130.629H128V130.017Z"
          fill="#DCE0E9"
          mask="url(#path-24-inside-11_302_34841)"
        />
        <mask id="path-26-inside-12_302_34841" fill="white">
          <path d="M76.6462 130.018H128V148.664H76.6462V130.018Z" />
        </mask>
        <path
          d="M128 148.664V148.052H76.6462V148.664V149.275H128V148.664Z"
          fill="#DCE0E9"
          mask="url(#path-26-inside-12_302_34841)"
        />
        <rect
          x="139.004"
          y="23.3363"
          width="29.345"
          height="3.66812"
          rx="1.83406"
          fill="#959CB1"
        />
        <mask id="path-29-inside-13_302_34841" fill="white">
          <path d="M128 36.7861H179.354V55.4324H128V36.7861Z" />
        </mask>
        <path
          d="M128 36.7861V37.4004H179.354V36.7861V36.1718H128V36.7861ZM179.354 55.4324V54.821H128V55.4324V56.0437H179.354V55.4324Z"
          fill="#DCE0E9"
          mask="url(#path-29-inside-13_302_34841)"
        />
        <mask id="path-31-inside-14_302_34841" fill="white">
          <path d="M128 55.4324H179.354V74.0787H128V55.4324Z" />
        </mask>
        <path
          d="M179.354 74.0787V73.4673H128V74.0787V74.69H179.354V74.0787Z"
          fill="#DCE0E9"
          mask="url(#path-31-inside-14_302_34841)"
        />
        <mask id="path-33-inside-15_302_34841" fill="white">
          <path d="M128 74.0786H179.354V92.7249H128V74.0786Z" />
        </mask>
        <path
          d="M179.354 92.7249V92.1135H128V92.7249V93.3363H179.354V92.7249Z"
          fill="#DCE0E9"
          mask="url(#path-33-inside-15_302_34841)"
        />
        <mask id="path-35-inside-16_302_34841" fill="white">
          <path d="M128 92.7249H179.354V111.371H128V92.7249Z" />
        </mask>
        <path
          d="M179.354 111.371V110.76H128V111.371V111.983H179.354V111.371Z"
          fill="#DCE0E9"
          mask="url(#path-35-inside-16_302_34841)"
        />
        <mask id="path-37-inside-17_302_34841" fill="white">
          <path d="M128 111.371H179.354V130.017H128V111.371Z" />
        </mask>
        <path
          d="M179.354 130.017V129.406H128V130.017V130.629H179.354V130.017Z"
          fill="#DCE0E9"
          mask="url(#path-37-inside-17_302_34841)"
        />
        <mask id="path-39-inside-18_302_34841" fill="white">
          <path d="M128 130.018H179.354V148.664H128V130.018Z" />
        </mask>
        <path
          d="M179.354 148.664V148.052H128V148.664V149.275H179.354V148.664Z"
          fill="#DCE0E9"
          mask="url(#path-39-inside-18_302_34841)"
        />
        <rect
          x="190.358"
          y="23.3363"
          width="29.345"
          height="3.66812"
          rx="1.83406"
          fill="#959CB1"
        />
        <mask id="path-42-inside-19_302_34841" fill="white">
          <path d="M179.354 36.7861H230.707V55.4324H179.354V36.7861Z" />
        </mask>
        <path
          d="M179.354 36.7861V37.4004H230.707V36.7861V36.1718H179.354V36.7861ZM230.707 55.4324V54.821H179.354V55.4324V56.0437H230.707V55.4324Z"
          fill="#DCE0E9"
          mask="url(#path-42-inside-19_302_34841)"
        />
        <mask id="path-44-inside-20_302_34841" fill="white">
          <path d="M179.354 55.4324H230.707V74.0787H179.354V55.4324Z" />
        </mask>
        <path
          d="M230.707 74.0787V73.4673H179.354V74.0787V74.69H230.707V74.0787Z"
          fill="#DCE0E9"
          mask="url(#path-44-inside-20_302_34841)"
        />
        <mask id="path-46-inside-21_302_34841" fill="white">
          <path d="M179.354 74.0786H230.707V92.7249H179.354V74.0786Z" />
        </mask>
        <path
          d="M230.707 92.7249V92.1135H179.354V92.7249V93.3363H230.707V92.7249Z"
          fill="#DCE0E9"
          mask="url(#path-46-inside-21_302_34841)"
        />
        <mask id="path-48-inside-22_302_34841" fill="white">
          <path d="M179.354 92.7249H230.707V111.371H179.354V92.7249Z" />
        </mask>
        <path
          d="M230.707 111.371V110.76H179.354V111.371V111.983H230.707V111.371Z"
          fill="#DCE0E9"
          mask="url(#path-48-inside-22_302_34841)"
        />
        <mask id="path-50-inside-23_302_34841" fill="white">
          <path d="M179.354 111.371H230.707V130.017H179.354V111.371Z" />
        </mask>
        <path
          d="M230.707 130.017V129.406H179.354V130.017V130.629H230.707V130.017Z"
          fill="#DCE0E9"
          mask="url(#path-50-inside-23_302_34841)"
        />
        <mask id="path-52-inside-24_302_34841" fill="white">
          <path d="M179.354 130.018H230.707V148.664H179.354V130.018Z" />
        </mask>
        <path
          d="M230.707 148.664V148.052H179.354V148.664V149.275H230.707V148.664Z"
          fill="#DCE0E9"
          mask="url(#path-52-inside-24_302_34841)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_302_34841"
          x="0.401733"
          y="0"
          width="255.196"
          height="180"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_302_34841"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_302_34841"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function EDTFromExistingIllustration() {
  return (
    <svg
      width="227"
      height="168"
      viewBox="0 0 227 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_302_34883)">
        <rect
          x="30.0847"
          y="14"
          width="179.33"
          height="116.667"
          rx="4.07569"
          fill="white"
        />
        <rect
          x="43.3308"
          y="20.1136"
          width="24.4541"
          height="3.05677"
          rx="1.52838"
          fill="#959CB1"
        />
        <mask id="path-3-inside-1_302_34883" fill="white">
          <path d="M34.1604 31.3218H76.9552V46.8604H34.1604V31.3218Z" />
        </mask>
        <path
          d="M34.1604 31.3218V31.8337H76.9552V31.3218V30.8098H34.1604V31.3218ZM76.9552 46.8604V46.3509H34.1604V46.8604V47.3698H76.9552V46.8604Z"
          fill="#DCE0E9"
          mask="url(#path-3-inside-1_302_34883)"
        />
        <mask id="path-5-inside-2_302_34883" fill="white">
          <path d="M34.1604 46.8604H76.9552V62.3989H34.1604V46.8604Z" />
        </mask>
        <path
          d="M76.9552 62.3989V61.8895H34.1604V62.3989V62.9084H76.9552V62.3989Z"
          fill="#DCE0E9"
          mask="url(#path-5-inside-2_302_34883)"
        />
        <mask id="path-7-inside-3_302_34883" fill="white">
          <path d="M34.1604 62.3989H76.9552V77.9374H34.1604V62.3989Z" />
        </mask>
        <path
          d="M76.9552 77.9374V77.428H34.1604V77.9374V78.4469H76.9552V77.9374Z"
          fill="#DCE0E9"
          mask="url(#path-7-inside-3_302_34883)"
        />
        <mask id="path-9-inside-4_302_34883" fill="white">
          <path d="M34.1604 77.9375H76.9552V93.4761H34.1604V77.9375Z" />
        </mask>
        <path
          d="M76.9552 93.4761V92.9666H34.1604V93.4761V93.9855H76.9552V93.4761Z"
          fill="#DCE0E9"
          mask="url(#path-9-inside-4_302_34883)"
        />
        <mask id="path-11-inside-5_302_34883" fill="white">
          <path d="M34.1604 93.4761H76.9552V109.015H34.1604V93.4761Z" />
        </mask>
        <path
          d="M76.9552 109.015V108.505H34.1604V109.015V109.524H76.9552V109.015Z"
          fill="#DCE0E9"
          mask="url(#path-11-inside-5_302_34883)"
        />
        <mask id="path-13-inside-6_302_34883" fill="white">
          <path d="M34.1604 109.015H76.9552V124.553H34.1604V109.015Z" />
        </mask>
        <path
          d="M76.9552 124.553V124.044H34.1604V124.553V125.063H76.9552V124.553Z"
          fill="#DCE0E9"
          mask="url(#path-13-inside-6_302_34883)"
        />
        <rect
          x="86.1255"
          y="20.1136"
          width="24.4541"
          height="3.05677"
          rx="1.52838"
          fill="#959CB1"
        />
        <mask id="path-16-inside-7_302_34883" fill="white">
          <path d="M76.9551 31.3218H119.75V46.8604H76.9551V31.3218Z" />
        </mask>
        <path
          d="M76.9551 31.3218V31.8337H119.75V31.3218V30.8098H76.9551V31.3218ZM119.75 46.8604V46.3509H76.9551V46.8604V47.3698H119.75V46.8604Z"
          fill="#DCE0E9"
          mask="url(#path-16-inside-7_302_34883)"
        />
        <mask id="path-18-inside-8_302_34883" fill="white">
          <path d="M76.9551 46.8604H119.75V62.3989H76.9551V46.8604Z" />
        </mask>
        <path
          d="M119.75 62.3989V61.8895H76.9551V62.3989V62.9084H119.75V62.3989Z"
          fill="#DCE0E9"
          mask="url(#path-18-inside-8_302_34883)"
        />
        <mask id="path-20-inside-9_302_34883" fill="white">
          <path d="M76.9551 62.3989H119.75V77.9374H76.9551V62.3989Z" />
        </mask>
        <path
          d="M119.75 77.9374V77.428H76.9551V77.9374V78.4469H119.75V77.9374Z"
          fill="#DCE0E9"
          mask="url(#path-20-inside-9_302_34883)"
        />
        <mask id="path-22-inside-10_302_34883" fill="white">
          <path d="M76.9551 77.9375H119.75V93.4761H76.9551V77.9375Z" />
        </mask>
        <path
          d="M119.75 93.4761V92.9666H76.9551V93.4761V93.9855H119.75V93.4761Z"
          fill="#DCE0E9"
          mask="url(#path-22-inside-10_302_34883)"
        />
        <mask id="path-24-inside-11_302_34883" fill="white">
          <path d="M76.9551 93.4761H119.75V109.015H76.9551V93.4761Z" />
        </mask>
        <path
          d="M119.75 109.015V108.505H76.9551V109.015V109.524H119.75V109.015Z"
          fill="#DCE0E9"
          mask="url(#path-24-inside-11_302_34883)"
        />
        <mask id="path-26-inside-12_302_34883" fill="white">
          <path d="M76.9551 109.015H119.75V124.553H76.9551V109.015Z" />
        </mask>
        <path
          d="M119.75 124.553V124.044H76.9551V124.553V125.063H119.75V124.553Z"
          fill="#DCE0E9"
          mask="url(#path-26-inside-12_302_34883)"
        />
        <rect
          x="128.92"
          y="20.1136"
          width="24.4541"
          height="3.05677"
          rx="1.52838"
          fill="#959CB1"
        />
        <mask id="path-29-inside-13_302_34883" fill="white">
          <path d="M119.75 31.3218H162.545V46.8604H119.75V31.3218Z" />
        </mask>
        <path
          d="M119.75 31.3218V31.8337H162.545V31.3218V30.8098H119.75V31.3218ZM162.545 46.8604V46.3509H119.75V46.8604V47.3698H162.545V46.8604Z"
          fill="#DCE0E9"
          mask="url(#path-29-inside-13_302_34883)"
        />
        <mask id="path-31-inside-14_302_34883" fill="white">
          <path d="M119.75 46.8604H162.545V62.3989H119.75V46.8604Z" />
        </mask>
        <path
          d="M162.545 62.3989V61.8895H119.75V62.3989V62.9084H162.545V62.3989Z"
          fill="#DCE0E9"
          mask="url(#path-31-inside-14_302_34883)"
        />
        <mask id="path-33-inside-15_302_34883" fill="white">
          <path d="M119.75 62.3989H162.545V77.9374H119.75V62.3989Z" />
        </mask>
        <path
          d="M162.545 77.9374V77.428H119.75V77.9374V78.4469H162.545V77.9374Z"
          fill="#DCE0E9"
          mask="url(#path-33-inside-15_302_34883)"
        />
        <mask id="path-35-inside-16_302_34883" fill="white">
          <path d="M119.75 77.9375H162.545V93.4761H119.75V77.9375Z" />
        </mask>
        <path
          d="M162.545 93.4761V92.9666H119.75V93.4761V93.9855H162.545V93.4761Z"
          fill="#DCE0E9"
          mask="url(#path-35-inside-16_302_34883)"
        />
        <mask id="path-37-inside-17_302_34883" fill="white">
          <path d="M119.75 93.4761H162.545V109.015H119.75V93.4761Z" />
        </mask>
        <path
          d="M162.545 109.015V108.505H119.75V109.015V109.524H162.545V109.015Z"
          fill="#DCE0E9"
          mask="url(#path-37-inside-17_302_34883)"
        />
        <mask id="path-39-inside-18_302_34883" fill="white">
          <path d="M119.75 109.015H162.545V124.553H119.75V109.015Z" />
        </mask>
        <path
          d="M162.545 124.553V124.044H119.75V124.553V125.063H162.545V124.553Z"
          fill="#DCE0E9"
          mask="url(#path-39-inside-18_302_34883)"
        />
        <rect
          x="171.715"
          y="20.1136"
          width="24.4541"
          height="3.05677"
          rx="1.52838"
          fill="#959CB1"
        />
        <mask id="path-42-inside-19_302_34883" fill="white">
          <path d="M162.545 31.3218H205.339V46.8604H162.545V31.3218Z" />
        </mask>
        <path
          d="M162.545 31.3218V31.8337H205.339V31.3218V30.8098H162.545V31.3218ZM205.339 46.8604V46.3509H162.545V46.8604V47.3698H205.339V46.8604Z"
          fill="#DCE0E9"
          mask="url(#path-42-inside-19_302_34883)"
        />
        <mask id="path-44-inside-20_302_34883" fill="white">
          <path d="M162.545 46.8604H205.339V62.3989H162.545V46.8604Z" />
        </mask>
        <path
          d="M205.339 62.3989V61.8895H162.545V62.3989V62.9084H205.339V62.3989Z"
          fill="#DCE0E9"
          mask="url(#path-44-inside-20_302_34883)"
        />
        <mask id="path-46-inside-21_302_34883" fill="white">
          <path d="M162.545 62.3989H205.339V77.9374H162.545V62.3989Z" />
        </mask>
        <path
          d="M205.339 77.9374V77.428H162.545V77.9374V78.4469H205.339V77.9374Z"
          fill="#DCE0E9"
          mask="url(#path-46-inside-21_302_34883)"
        />
        <mask id="path-48-inside-22_302_34883" fill="white">
          <path d="M162.545 77.9375H205.339V93.4761H162.545V77.9375Z" />
        </mask>
        <path
          d="M205.339 93.4761V92.9666H162.545V93.4761V93.9855H205.339V93.4761Z"
          fill="#DCE0E9"
          mask="url(#path-48-inside-22_302_34883)"
        />
        <mask id="path-50-inside-23_302_34883" fill="white">
          <path d="M162.545 93.4761H205.339V109.015H162.545V93.4761Z" />
        </mask>
        <path
          d="M205.339 109.015V108.505H162.545V109.015V109.524H205.339V109.015Z"
          fill="#DCE0E9"
          mask="url(#path-50-inside-23_302_34883)"
        />
        <mask id="path-52-inside-24_302_34883" fill="white">
          <path d="M162.545 109.015H205.339V124.553H162.545V109.015Z" />
        </mask>
        <path
          d="M205.339 124.553V124.044H162.545V124.553V125.063H205.339V124.553Z"
          fill="#DCE0E9"
          mask="url(#path-52-inside-24_302_34883)"
        />
      </g>
      <g filter="url(#filter1_d_302_34883)">
        <rect
          x="12.5847"
          y="37.3333"
          width="179.167"
          height="116.667"
          rx="4.0404"
          fill="white"
        />
        <rect
          x="24.3745"
          y="43.3939"
          width="24.2424"
          height="3.0303"
          rx="1.51515"
          fill="#959CB1"
        />
        <rect
          x="16.625"
          y="54.5051"
          width="39.7412"
          height="8.58586"
          rx="2.0202"
          fill="#91ABF1"
        />
        <rect
          x="16.625"
          y="65.1113"
          width="39.7412"
          height="5.05051"
          rx="2.0202"
          fill="#E8EAF0"
        />
        <rect
          x="16.625"
          y="72.1819"
          width="39.7412"
          height="17.6768"
          rx="2.0202"
          fill="#D8EF95"
        />
        <rect
          x="16.625"
          y="91.879"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFB3C2"
        />
        <rect
          x="16.625"
          y="107.03"
          width="39.7412"
          height="25.7576"
          rx="2.0202"
          fill="#BDC9EA"
        />
        <rect
          x="16.625"
          y="134.808"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFA573"
        />
        <rect
          x="68.156"
          y="43.3939"
          width="24.2424"
          height="3.0303"
          rx="1.51515"
          fill="#959CB1"
        />
        <rect
          x="60.4065"
          y="54.5051"
          width="39.7412"
          height="5.05051"
          rx="2.0202"
          fill="#E8EAF0"
        />
        <rect
          x="60.4065"
          y="61.5759"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFB3C2"
        />
        <rect
          x="60.4065"
          y="76.7274"
          width="39.7412"
          height="8.58586"
          rx="2.0202"
          fill="#91ABF1"
        />
        <rect
          x="60.4065"
          y="87.3335"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFA573"
        />
        <rect
          x="60.4065"
          y="102.485"
          width="39.7412"
          height="25.7576"
          rx="2.0202"
          fill="#BDC9EA"
        />
        <rect
          x="60.4065"
          y="130.263"
          width="39.7412"
          height="17.6768"
          rx="2.0202"
          fill="#D8EF95"
        />
        <rect
          x="111.938"
          y="43.3939"
          width="24.2424"
          height="3.0303"
          rx="1.51515"
          fill="#959CB1"
        />
        <rect
          x="104.188"
          y="54.5051"
          width="39.7412"
          height="5.05051"
          rx="2.0202"
          fill="#E8EAF0"
        />
        <rect
          x="104.188"
          y="61.5759"
          width="39.7412"
          height="17.6768"
          rx="2.0202"
          fill="#D8EF95"
        />
        <rect
          x="104.188"
          y="81.2728"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFB3C2"
        />
        <rect
          x="104.188"
          y="96.4244"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFA573"
        />
        <rect
          x="104.188"
          y="111.576"
          width="39.7412"
          height="25.7576"
          rx="2.0202"
          fill="#BDC9EA"
        />
        <rect
          x="104.188"
          y="139.354"
          width="39.7412"
          height="8.58586"
          rx="2.0202"
          fill="#91ABF1"
        />
        <rect
          x="155.719"
          y="43.3939"
          width="24.2424"
          height="3.0303"
          rx="1.51515"
          fill="#959CB1"
        />
        <rect
          x="147.969"
          y="54.5051"
          width="39.7412"
          height="17.6768"
          rx="2.0202"
          fill="#D8EF95"
        />
        <rect
          x="147.969"
          y="74.2022"
          width="39.7412"
          height="8.58586"
          rx="2.0202"
          fill="#91ABF1"
        />
        <rect
          x="147.969"
          y="84.8082"
          width="39.7412"
          height="5.05051"
          rx="2.0202"
          fill="#E8EAF0"
        />
        <rect
          x="147.969"
          y="91.879"
          width="39.7412"
          height="25.7576"
          rx="2.0202"
          fill="#BDC9EA"
        />
        <rect
          x="147.969"
          y="119.657"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFA573"
        />
        <rect
          x="147.969"
          y="134.808"
          width="39.7412"
          height="13.1313"
          rx="2.0202"
          fill="#FFB3C2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_302_34883"
          x="13.4181"
          y="0.666667"
          width="212.664"
          height="150"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.33333" />
          <feGaussianBlur stdDeviation="8.33333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_302_34883"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_302_34883"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_302_34883"
          x="0.918051"
          y="28"
          width="202.5"
          height="140"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.33333" />
          <feGaussianBlur stdDeviation="5.83333" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_302_34883"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_302_34883"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function EDTFromTemplateIllustration() {
  return (
    <svg
      width="244"
      height="169"
      viewBox="0 0 244 169"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_321_37493)">
        <rect
          x="14.5"
          y="12"
          width="215"
          height="140"
          rx="4.84848"
          fill="white"
        />
        <rect
          x="37.4041"
          y="19.3636"
          width="29.0909"
          height="3.63636"
          rx="1.81818"
          fill="#959CB1"
        />
        <rect
          x="19.3484"
          y="32.6967"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="19.3484"
          y="44.9998"
          width="31.3889"
          height="6.06061"
          rx="2.42424"
          fill="#E8EAF0"
        />
        <rect
          x="19.3484"
          y="53.0604"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="19.3484"
          y="76.2725"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D8EF95"
        />
        <rect
          x="19.3484"
          y="94.03"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#FFE366"
        />
        <rect
          x="19.3484"
          y="126.939"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#C9CDDB"
        />
        <rect
          x="53.1616"
          y="32.6967"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="53.1616"
          y="44.9998"
          width="31.3889"
          height="6.06061"
          rx="2.42424"
          fill="#E8EAF0"
        />
        <rect
          x="53.1616"
          y="53.0604"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#FFE366"
        />
        <rect
          x="53.1616"
          y="85.9694"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="53.1616"
          y="109.182"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#FF797A"
        />
        <rect
          x="53.1616"
          y="126.939"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D8EF95"
        />
        <rect
          x="107.455"
          y="19.2727"
          width="29.0909"
          height="3.63636"
          rx="1.81818"
          fill="#959CB1"
        />
        <rect
          x="89.3989"
          y="32.6058"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="89.3989"
          y="55.8179"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="89.3989"
          y="68.121"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D8EF95"
        />
        <rect
          x="89.3989"
          y="85.8785"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#AE9AF9"
        />
        <rect
          x="89.3989"
          y="118.788"
          width="31.3889"
          height="24"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="123.212"
          y="32.6058"
          width="31.3889"
          height="6.06061"
          rx="2.42424"
          fill="#E8EAF0"
        />
        <rect
          x="123.212"
          y="40.6664"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#AE9AF9"
        />
        <rect
          x="123.212"
          y="73.5756"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="123.212"
          y="96.7877"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#FF797A"
        />
        <rect
          x="123.212"
          y="114.545"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="123.212"
          y="126.848"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D8EF95"
        />
        <rect
          x="177.505"
          y="19.3636"
          width="29.0909"
          height="3.63636"
          rx="1.81818"
          fill="#959CB1"
        />
        <rect
          x="159.449"
          y="32.6967"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#D8EF95"
        />
        <rect
          x="159.449"
          y="65.6058"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#D7EAEC"
        />
        <rect
          x="159.449"
          y="88.8179"
          width="31.3889"
          height="6.06061"
          rx="2.42424"
          fill="#FF797A"
        />
        <rect
          x="159.449"
          y="96.8785"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="159.449"
          y="109.182"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#BDC9EA"
        />
        <rect
          x="159.449"
          y="126.939"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D7EAEC"
        />
        <rect
          x="193.263"
          y="32.6967"
          width="31.3889"
          height="6.06061"
          rx="2.42424"
          fill="#E8EAF0"
        />
        <rect
          x="193.263"
          y="40.7573"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#D7EAEC"
        />
        <rect
          x="193.263"
          y="58.5149"
          width="31.3889"
          height="21.2121"
          rx="2.42424"
          fill="#FFE366"
        />
        <rect
          x="193.263"
          y="81.7271"
          width="31.3889"
          height="10.303"
          rx="2.42424"
          fill="#91ABF1"
        />
        <rect
          x="193.263"
          y="94.03"
          width="31.3889"
          height="30.9091"
          rx="2.42424"
          fill="#81D0B0"
        />
        <rect
          x="193.263"
          y="126.939"
          width="31.3889"
          height="15.7576"
          rx="2.42424"
          fill="#BDC9EA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_321_37493"
          x="0.5"
          y="0.8"
          width="243"
          height="168"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.8" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_321_37493"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_321_37493"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
